import React from 'react';
import { Box } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

import useStyles from './styles';

const Loading = () => {
  const classes = useStyles();

  return (
    <Box className={classes.container}>
      <Box className="professional-content">
        <Skeleton
          variant="circle"
          className="professional-icon"
          width={48}
          height={48}
        />
        <Box className="professional-infos-container">
          <Box className="professional-infos-box name">
            <Skeleton variant="text" width="20%" />
            <Skeleton variant="text" width="60%" />
          </Box>
          <Box className="professional-infos-box contact">
            <Skeleton variant="text" width="20%" />
            <Skeleton variant="text" width="80%" />
          </Box>
          <Box className="professional-infos-box description">
            <Skeleton variant="text" width="20%" />
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="100%" />
            <Skeleton variant="text" width="50%" />
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default Loading;
